<template>
  <VModalContainer :class="variantClassName" :prevent-closing="preventClosing" @close="emitClose">
    <div :class="['modal-container-ui', variantClassName]">
      <div class="modal-container-ui__header">
        <slot name="header" :title="title" :description="description">
          <ModalContainerTitle v-if="title" :class="variantClassName"
            >{{ title }}
          </ModalContainerTitle>
          <ModalContainerDesc v-if="description">{{ description }}</ModalContainerDesc>
        </slot>
      </div>
      <slot />
    </div>
  </VModalContainer>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';

  // Components
  import VModalContainer from '~/misc/v-modal-container';
  import ModalContainerTitle from '~/misc/modal/container/title/ModalContainerTitle.vue';
  import ModalContainerDesc from '~/misc/modal/container/desc/ModalContainerDesc.vue';

  export default defineComponent({
    name: 'ModalContainer',
    components: {
      VModalContainer,
      ModalContainerTitle,
      ModalContainerDesc,
    },
    props: {
      title: {
        type: String,
        default: undefined,
      },
      description: {
        type: String,
        default: undefined,
      },
      preventClosing: {
        type: Boolean,
        default: false,
      },
      variantClassName: {
        type: String,
        default: '',
      },
    },
    emits: ['close'],
    methods: {
      emitClose() {
        this.$emit('close');
      },
    },
  });
</script>
